export const InviteLoginStatuses = {
  /*
  warn user there is no code to show and give link to login view, maybe auto-redirect
  (Needs UX review - currently just redirects to login)
   */
  NO_CODE: 'NO_CODE',

  /*
  inform user their information is being retrieved from the  server: show a loading spinner or something
   */
  LOADING: 'LOADING',

  /*
  Inform user the code they used is expired and provide a button to request a new code via email
   */
  EXPIRED_CODE: 'EXPIRED_CODE',

  /*
  Code request in progress
   */
  REQUESTING_CODE: 'REQUESTING_CODE',

  /*
  Inform user that a new code hs been requested, they should check their email
   */
  REQUESTING_CODE_SUCCESS: 'REQUESTING_CODE_SUCCESS',

  /*
  Inform user the request failed and suggest to contact the person that invited them
   */
  REQUESTING_CODE_ERROR: 'REQUESTING_CODE_ERROR',

  /*
  Inform user the invitation does not exist. It may have been cancelled or accepted/rejected already
   */
  NO_INVITE: 'NO_INVITE',

  /*
  Display the invitation data and allow the user to sign in or create an account
   */
  VALID_CODE_NEED_AUTH: 'VALID_CODE_NEED_AUTH',

  /*
  redirects immediately to the invite response view
  TODO: (needs UX review)
   */
  VALID_CODE_HAVE_AUTH: 'VALID_CODE_HAVE_AUTH',

  /*
  an unexpected error occurred. warn user? Plausibly lack of connection
   */
  ERROR: 'ERROR',
};



// WEBPACK FOOTER //
// ./src/js/auth/enums/InviteLoginStatuses.js